import { render, staticRenderFns } from "./ExceededWarn.vue?vue&type=template&id=c52b3906&"
import script from "./ExceededWarn.vue?vue&type=script&lang=js&"
export * from "./ExceededWarn.vue?vue&type=script&lang=js&"
import style0 from "./ExceededWarn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports